<template>
  <div class="scheme">
    <div class="scheme_h">
      <img :src="orderInfoData.logo" alt="" />
      <h3>
        {{ orderInfoData.productName }}
      </h3>
    </div>
    <div class="scheme_h_tips">以下内容均以实际放款为准</div>
    <div class="scheme_m">
      <div class="scheme_m_t">
        <div class="scheme_m_t_header">
          <img src="https://oss.swiftfintech.com/txfq_cg/h5/icon_money.png" alt="" />
          <h3>借款方案</h3>
        </div>
        <div class="scheme_m_t_money">
          <span>{{
            orderInfoData.minAmount
              ? numberFormat(orderInfoData.minAmount, ' ', 0)
              : numberFormat(10000, ' ', 0)
          }}</span>
          <span>
            -{{
              orderInfoData.maxAmount
                ? numberFormat(orderInfoData.maxAmount, ' ', 0)
                : numberFormat(200000, ' ', 0)
            }}</span
          >
        </div>
      </div>
      <div class="scheme_m_b">
        <div class="scheme_m_b_item">
          <img src="https://oss.swiftfintech.com/txfq_cg/h5/icon_statistics.png" alt="" />
          <div class="scheme_m_b_item_title">年化利率</div>
          <div class="scheme_m_b_item_content">
            {{ orderInfoData.minLoanRate ? orderInfoData.minLoanRate : 0 }}% -
            {{ orderInfoData.maxLoanRate ? orderInfoData.maxLoanRate : 0 }}%
          </div>
        </div>
        <div class="scheme_m_b_item">
          <img src="https://oss.swiftfintech.com/txfq_cg/h5/icon_calendar.png" alt="" />
          <div class="scheme_m_b_item_title">支持期限</div>
          <div class="scheme_m_b_item_content">
            {{ orderInfoData.loanPeriodStart }} - {{ orderInfoData.loanPeriodEnd }} 期
          </div>
        </div>
        <div class="scheme_m_b_item">
          <img
            class="scheme_m_b_item_icon"
            src="https://oss.swiftfintech.com/txfq_cg/h5/icon_institution.png"
            alt=""
          />
          <div class="scheme_m_b_item_title">借款顾问</div>
          <div class="scheme_m_b_item_content">
            {{ orderInfoData.companyName ? orderInfoData.companyName : '-' }}
          </div>
        </div>
      </div>
    </div>
    <div class="scheme_b">
      此方案由
      <span class="scheme_b_color">{{
        orderInfoData.companyName ? orderInfoData.companyName : '--'
      }}</span
      >合作方，<span class="scheme_b_color">{{
        orderInfoData.companyName ? orderInfoData.companyName : '--'
      }}</span
      >提供
      <br />
      请注意接听客户经理来电，以便为您定制具体贷款方案
    </div>
  </div>
</template>

<script>
export default {
  name: 'Scheme',
  props: { orderInfoData: Object },
  data() {
    return {}
  },
  components: {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.scheme {
  width: 100%;
  padding: 0.3rem;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;
  .scheme_h {
    display: flex;
    > img {
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
    }
    > h3 {
      font-size: 0.38rem;
      font-weight: 600;
      color: #02081a;
      margin-left: 0.1rem;
    }
  }
  .scheme_h_tips {
    font-size: 0.26rem;
    color: rgba(126, 132, 153, 0.6);
    margin: 0.1rem 0 0.2rem 0.6rem;
  }
  .scheme_m {
    position: relative;
    z-index: 3;
    padding: 0.3rem;
    background: url('https://oss.swiftfintech.com/txfq_cg/h5/bg_combined_yellow.png') no-repeat;
    background-size: 100%;
    // background: linear-gradient(314deg, #ffefca 0%, #fdf7e7 100%);
    // box-shadow: inset 0px -5px 16px 0px #ffebc3;
    border-radius: 0.2rem;
    .scheme_m_t {
      .scheme_m_t_header {
        display: flex;
        align-items: center;
        > img {
          width: 0.3rem;
          height: 0.34rem;
          // width: 0.5rem;
          // height: 0.5rem;
          // border-radius: 50%;
        }
        > h3 {
          font-size: 0.32rem;
          font-weight: 600;
          color: #1a1e2e;
          margin-left: 0.1rem;
        }
      }
      .scheme_m_t_money {
        min-height: 0.6rem;
        margin-top: 0.18rem;
        font-size: 0.6rem;
        color: #f63138;
        font-weight: bold;
      }
    }
    .scheme_m_b {
      position: relative;
      // border-top: 2px dashed rgba(126, 132, 153, 0.1);
      // padding: 0.3rem 0 0;
      margin-top: 0.48rem;
      .scheme_m_b_item {
        display: flex;
        justify-content: space-between;
        // align-items: center;
        // align-content: flex-end;
        border-radius: 0.1rem;
        padding: 0.1rem;
        > img {
          flex: 0 0 0.3rem;
          align-self: center;
          width: 0.3rem;
          height: 0.3rem;
        }
        > img.scheme_m_b_item_icon {
          align-self: flex-start;
        }
        .scheme_m_b_item_title {
          flex: 0 0 calc(40% - 0.5rem);
          font-size: 0.24rem;
          font-weight: 600;
          color: #623612;
        }
        .scheme_m_b_item_content {
          flex: 0 0 60%;
          text-align: right;
          font-size: 0.24rem;
          color: #ff4734;
        }
      }
    }
    // .scheme_m_b::before,
    // .scheme_m_b::after {
    //   content: "";
    //   position: absolute;
    //   width: 20px; /* 半径的两倍 */
    //   height: 20px; /* 半径的两倍 */
    //   background-color: #ffffff; /* 白色 */
    //   border-radius: 50%; /* 创建圆形 */
    // }
    // .scheme_m_b::before {
    //   top: -10px; /* 调整位置 */
    //   left: -25px;
    // }
    // .scheme_m_b::after {
    //   top: -10px;
    //   right: -25px;
    // }
  }
  .scheme_b {
    z-index: 1;
    width: 100%;
    font-size: 0.22rem;
    background-color: #f4f6ff;
    border-bottom-right-radius: 0.2rem;
    border-bottom-left-radius: 0.2rem;
    text-align: center;
    color: #7e8499;
    margin-top: -0.2rem;
    line-height: 1.5;
    padding: 0.5rem 0 0.3rem;
    .scheme_b_color {
      color: #4361ff;
    }
  }
}
</style>
